import { c as _c } from "react/compiler-runtime";
import { Stack } from '@mui/material';
import { useState } from 'react';
import { Accordion, AccordionDetails, AccordionSummary } from '@/components/accordion';
import { Loader } from '@/components/layout/loading';
import { SelectedItemsBody } from './selectedItemsBody';
import { SelectedItemsHeader } from './selectedItemsHeader';
export const SelectionPanel = t0 => {
  const $ = _c(14);
  const {
    isLoading,
    drawerProps,
    children
  } = t0;
  const [expanded, setExpanded] = useState(false);
  const showDrawer = drawerProps.items.length > 0;
  if (isLoading) {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <Stack className="h-[220px]"><Loader /></Stack>;
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    return t1;
  }
  const t1 = showDrawer ? "60px" : 0;
  let t2;
  if ($[1] !== t1) {
    t2 = {
      paddingBottom: t1
    };
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const t3 = expanded ? "block" : "none";
  let t4;
  if ($[3] !== t3) {
    t4 = <Stack className="absolute top-0 left-0 w-full h-full" sx={{
      background: "var(--mui-palette-custom-PURPLE-01)",
      display: t3,
      zIndex: 1
    }} />;
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== drawerProps || $[6] !== expanded || $[7] !== showDrawer) {
    t5 = showDrawer && <SelectedItemsDrawer {...drawerProps} expanded={expanded} setExpanded={setExpanded} />;
    $[5] = drawerProps;
    $[6] = expanded;
    $[7] = showDrawer;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== children || $[10] !== t2 || $[11] !== t4 || $[12] !== t5) {
    t6 = <Stack className="max-h-[480px] overflow-hidden" sx={t2}>{children}{t4}{t5}</Stack>;
    $[9] = children;
    $[10] = t2;
    $[11] = t4;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  return t6;
};
interface SelectedItemsDrawerProps<T> {
  entityType: string;
  items: T[];
  onRemove: (item: T) => void;
  renderItem: (item: T) => React.ReactNode;
  itemKey: (item: T) => string;
  clearAll: () => void;
  expanded: boolean;
  setExpanded: (expanded: boolean) => void;
}
const SelectedItemsDrawer = t0 => {
  const $ = _c(26);
  const {
    entityType,
    items,
    renderItem,
    itemKey,
    onRemove,
    clearAll,
    expanded,
    setExpanded
  } = t0;
  let t1;
  if ($[0] !== expanded || $[1] !== items.length || $[2] !== setExpanded) {
    t1 = items.length ? () => setExpanded(!expanded) : undefined;
    $[0] = expanded;
    $[1] = items.length;
    $[2] = setExpanded;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      zIndex: 2,
      maxHeight: "calc(100% - 60px)",
      backgroundColor: "var(--mui-palette-background-paper)",
      "& .MuiCollapse-root": {
        backgroundColor: "var(--mui-palette-background-paper)",
        position: "relative",
        overflow: "auto"
      }
    };
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      boxShadow: "var(--mui-customShadows-panel)"
    };
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const t4 = `${items.length} ${items.length === 1 ? entityType : `${entityType}${entityType.endsWith("s") ? "es" : "s"}`} selected`;
  let t5;
  if ($[6] !== clearAll || $[7] !== setExpanded) {
    t5 = () => {
      clearAll();
      setExpanded(false);
    };
    $[6] = clearAll;
    $[7] = setExpanded;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t4 || $[10] !== t5) {
    t6 = <AccordionSummary className="min-h-[64px] h-[64px] px-[24px]" sx={t3}><SelectedItemsHeader title={t4} clearAll={t5} /></AccordionSummary>;
    $[9] = t4;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== items.length || $[13] !== onRemove || $[14] !== setExpanded) {
    t7 = item => {
      if (items.length === 1) {
        setExpanded(false);
      }
      onRemove(item);
    };
    $[12] = items.length;
    $[13] = onRemove;
    $[14] = setExpanded;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== itemKey || $[17] !== items || $[18] !== renderItem || $[19] !== t7) {
    t8 = <AccordionDetails className="p-0 overflow-auto"><SelectedItemsBody items={items} renderItem={renderItem} itemKey={itemKey} onRemove={t7} /></AccordionDetails>;
    $[16] = itemKey;
    $[17] = items;
    $[18] = renderItem;
    $[19] = t7;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  let t9;
  if ($[21] !== expanded || $[22] !== t1 || $[23] !== t6 || $[24] !== t8) {
    t9 = <Accordion expanded={expanded} onChange={t1} className="p-0 m-0 flex flex-col absolute bottom-0 left-0 right-0" sx={t2}>{t6}{t8}</Accordion>;
    $[21] = expanded;
    $[22] = t1;
    $[23] = t6;
    $[24] = t8;
    $[25] = t9;
  } else {
    t9 = $[25];
  }
  return t9;
};